// Define a mapping between sources slugs and category/subcategory/subsection on the sheet.
// The values here cannot be translated because they refer to sheet cell values.
const sources = new Map();

sources.set('allSources', [null, null, null]);
sources.set('chip', ['Health Insurance', 'CHIP (Title XIX and Title XXI)', null]);
sources.set('departmentOfDefense', ['Health Insurance', 'Department of Defense', null]);
sources.set('departmentOfVeteransAffairs', ['Health Insurance', 'Department of Veterans Affairs', null]);
sources.set('federal', ['Public Health Activity', 'Federal', null]);
sources.set('generalAssistance', ['Other Third Party Payers and Programs', 'General Assistance', null]);
sources.set('healthInsurance', ['Health Insurance', null, null]);
sources.set('indianHealthServices', ['Other Third Party Payers and Programs', 'Indian Health Services', null]);
sources.set('investment', ['Investment', null, null]);
sources.set('maternalChildHealth', ['Other Third Party Payers and Programs', 'Maternal/Child Health', null]);
sources.set('medicaid', ['Health Insurance', 'Medicaid (Title XIX)', null]);
sources.set('medicare', ['Health Insurance', 'Medicare', null]);
sources.set('otherFederalPrograms', ['Other Third Party Payers and Programs', 'Other Federal Programs*', null]);
sources.set('otherPrivateRevenues', ['Other Third Party Payers and Programs', 'Other Private Revenues', null]);
sources.set('otherStateAndLocalPrograms', ['Other Third Party Payers and Programs', 'Other State and Local Programs**', null]);
sources.set('otherThirdParty', ['Other Third Party Payers and Programs', null, null]);
sources.set('outOfPocket', ['Out of Pocket', null, null]);
sources.set('privateHealthInsurance', ['Health Insurance', 'Private Health Insurance', null]);
sources.set('publicHealthActivity', ['Public Health Activity', null, null]);
sources.set('research', ['Investment', 'Research', null]);
sources.set('samhsa', ['Other Third Party Payers and Programs', 'SAMHSA', null]);
sources.set('schoolHealth', ['Other Third Party Payers and Programs', 'School Health', null]);
sources.set('stateAndLocal', ['Public Health Activity', 'State and Local', null]);
sources.set('structures', ['Investment', 'Structures', null]);
sources.set('structuresAndEquipment', ['Investment', 'Structures & Equipment', null]);
sources.set('totalCMSPrograms', ['Total CMS Programs (Medicaid, CHIP and Medicare)', null, null]);
sources.set('vocationalRehabilitation', ['Other Third Party Payers and Programs', 'Vocational Rehabilitation', null]);
sources.set('workersCompensation', ['Other Third Party Payers and Programs', 'Workers\' Compensation', null]);
sources.set('worksiteHealthCare', ['Other Third Party Payers and Programs', 'Worksite Health Care', null]);

export default sources;
